import './background.css';
import * as React from 'react';

type Props = {
    children: React.ReactNode;
    ratio?: string;
    backgroundImageUrl: string;
    backgroundHeight: number;
    backgroundWidth: number;
    enabled: boolean;
};

const Background = ({ children, ratio = '67%', backgroundImageUrl, backgroundHeight, backgroundWidth, enabled }: Props) => (
    <div
        className="background"
        style={{
            position: 'relative',
            width: '100%',
            height: enabled ? '0' : backgroundHeight,
            paddingTop: enabled ? ratio : 0,
            maxWidth: `${backgroundWidth}px`,
            maxHeight: `${backgroundHeight}px`,
            backgroundImage: `url('${backgroundImageUrl}')`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            border: enabled ? '0.5px solid #D5DBE4' : 'none',
            borderRadius: '8px',
        }}>
        <div
            style={{
                position: 'absolute',
                top: '0',
                left: '0',
                width: '100%',
                height: '100%',
            }}>
            {children}
        </div>
    </div>
);

export default Background;
